import type { PortfolioAdminCard } from '@repo/api-contracts';
import type { ButtonHTMLAttributes, HTMLAttributes } from 'react';
import { usePortfolioDetailQuery } from '@/entities/portfolio';
import { OrderMoveControls } from '@/shared/ui';

export const PortfolioOrderRow = ({
  id,
  item,
  first,
  last,
  disabled,
  onMove,
  handleProps,
  rowProps,
  dropEdge,
}: {
  id: string;
  item?: PortfolioAdminCard;
  first: boolean;
  last: boolean;
  disabled: boolean;
  onMove: (direction: 'UP' | 'DOWN') => void;
  handleProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  rowProps?: HTMLAttributes<HTMLLIElement>;
  dropEdge?: 'before' | 'after';
}) => {
  const detail = usePortfolioDetailQuery(id, !item);
  const current = item ?? detail.data;
  const title = current?.title ?? `사례 ${id}`;
  return (
    <li
      {...rowProps}
      className="relative flex min-w-0 snap-start flex-col rounded-xl border bg-background"
    >
      {dropEdge ? (
        <span
          className={`pointer-events-none absolute inset-y-0 z-10 border-l-2 border-primary text-xs text-primary ${dropEdge === 'before' ? '-left-1' : '-right-1'}`}
        >
          여기에 놓기
        </span>
      ) : null}
      {current ? (
        <img
          src={current.imageUrl}
          alt={`${title} 대표사진`}
          className="aspect-[4/3] w-full shrink-0 rounded-t-xl bg-muted object-cover"
          loading="lazy"
          draggable={false}
        />
      ) : (
        <div className="flex aspect-[4/3] w-full shrink-0 items-center justify-center rounded-t-xl bg-muted text-xs text-muted-foreground">
          사진 준비 중
        </div>
      )}
      <div className="min-w-0 flex-1 p-3">
        <span className="break-words font-semibold">{title}</span>
        {current?.clientName ? (
          <p className="mt-1 text-sm text-muted-foreground">{current.clientName}</p>
        ) : null}
        {current ? (
          <span
            className={`mt-2 inline-flex rounded-full px-2 py-0.5 text-xs ${current.isVisible ? 'bg-primary/10 text-foreground' : 'bg-muted text-muted-foreground'}`}
          >
            {current.isVisible ? '공개' : '비공개'}
          </span>
        ) : null}
        {!item && detail.isPending ? <p className="text-sm">제목을 불러오는 중…</p> : null}
        {!item && detail.isError ? (
          <p className="text-sm text-destructive">
            제목을 불러오지 못했습니다.{' '}
            <button type="button" onClick={() => void detail.refetch()}>
              다시 시도
            </button>
          </p>
        ) : null}
      </div>
      <div className="border-t p-2">
        <OrderMoveControls
          orientation="horizontal"
          title={title}
          first={first}
          last={last}
          disabled={disabled}
          onMove={onMove}
          handleProps={handleProps}
        />
      </div>
    </li>
  );
};
